import { useInactivityTimeout } from "hooks/useInactivityTimeout";
import { useAuth } from "providers/AuthProvider";

const UserInActive = () => {
  const { logout, user } = useAuth();

  useInactivityTimeout(
    () => {
      if (user) {
        console.log("User is inactive");
        logout("LOGIN");
      }
    },
    30 * 60 * 1000
  ); // 30 minutes

  return null;
};

export default UserInActive;
